class WuModal {
  constructor(modal) {
    this.modal = modal;
    this.isIframeNotNeeded = !!this.modal.getAttribute("data-iframe-needed");

    if (this.modal.querySelectorAll(`[data-wu-modal-trigger]`) == null) {
      return false;
    } else {
      this.modalTriggers = this.modal.querySelectorAll(
        `[data-wu-modal-trigger]`
      );
    }
    if (this.modal.querySelector(`[data-wu-modal-content]`) == null) {
      return false;
    } else {
      this.modalContent = this.modal.querySelector(`[data-wu-modal-content]`);
    }
    if (!this.isIframeNotNeeded) {
      if (this.modalContent.querySelector("iframe") == null) {
        return false;
      } else {
        this.frame = this.modalContent.querySelector("iframe");
      }
      if (this.frame.parentNode == null) {
        return false;
      } else {
        this.frameParent = this.frame.parentNode;
      }
    }
    this.init();
  }
  init() {
    this.triggerListenerClick();
  }
  triggerListenerClick() {
    for (let i = 0; i < this.modalTriggers.length; i++) {
      var urlParams = new URLSearchParams(window.location.search);
      if (
        urlParams.has("q") &&
        this.modalTriggers[i].getAttribute("id") === "openLoginModal"
      ) {
        const qparamvalue = urlParams.get("q");
        if (qparamvalue) {
          this.triggerHandlerClick();
        }
      }
      this.modalTriggers[i].addEventListener("click", (e) => {
        this.triggerHandlerClick(e);
      });
    }
  }
  triggerHandlerClick(e) {
    this.modalContent.classList.toggle("d-flex");
    this.modalContent.classList.toggle("d-none");
    if (!this.isIframeNotNeeded) {
      this.frame.remove();
      this.frameParent.appendChild(this.frame);
    }
  }
}

let allModals = document.querySelectorAll("[data-wu-modal]");
if (allModals.length > 0) {
  for (let i = 0; i < allModals.length; i++) {
    new WuModal(allModals[i]);
  }
}
